import styled, { keyframes } from 'styled-components'
export const Tile = styled.div`
    width: 100%;
    height: ${props => props.height};
    overflow: hidden;
    box-shadow: ${props => props.highlight ? "0px 0px 2px 2px red" : ""||props.boxShadow ||"none"};
    box-shadow: ${props => props.boxShadow};
`
 
export const Title = styled.div`
    width: 100%;
    height: 37px;
    text-align: left;
    padding: 5px 5px 2px 5px;
    box-shadow: #59595966 4px 0px 3px inset, 
				#59595966 0px 4px 4px inset, 
				#59595966 -4px 0px 3px inset;
    font-size: ${props => props.fontSize};
`
export const Body = styled.div`
    padding: ${props => props.padding||"5px 5px 3px 5px"};
    font-size:  ${props => props.fontSize||'14px'};
    height: ${props => props.height||"100%"};
    white-space: pre-wrap;
    display:  ${props => props.display||'block'};
    line-height: ${props => props.lineHeight||props.fontSize||'14px'};
    box-shadow: #333333 0px -2px 0px,  
                rgb(38, 38, 38) 0px 2px 0px, 
                rgba(0, 0, 0, 0.4) 0px 3px 3px, 
                rgba(255, 255, 255, 0.5) 0px 0px 3px inset, 
                black 1px 1px 4px 1px inset;
    border-left: 1px solid #5f5d5d66;
    border-right: 1px solid #5f5d5d7a;
    overflow: ${props => props.overflow||'hidden'};
`

export const RaisedPanel = styled.div`
    width: ${props => props.width||'100%'};
    height: ${props => props.height||'100%'}
    font-size:  ${props => props.fontSize||'14px'};
    lineHeight: ${props => props.lineHeight||props.fontSize||1};
    padding: 5px 5px 2px 5px;
    box-shadow: #59595966 4px 0px 3px inset, 
                #59595966 0px 4px 4px inset, 
                #59595966 -4px 0px 3px inset,
                #59595966 0px -5px 4px inset;
`
export const LoggingIndicator = styled.div`
    display: ${props => props.logStatus ? "block" : "none"||"none"};
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: red;

`

export const DisplayLogTitle = styled(Title)`
    font-size: 14px;


    @media (max-width: 576px) {
        font-size: 12px;  
    }  
`

export const Modal = styled.div`
    display: ${props => props.show ? 'block' : 'none' ||'none'};
    position: fixed; 
    z-index: 10001; 
    padding-top: 100px;
    padding-bottom: 100px;
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: ${props => props.overflow||'none'};
    background-color: #ffffff66; /* Fallback color */
   

    @media (max-width: 992px) {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    
    @media (max-width: 576px) {
        padding-top: 10px;
        padding-bottom: 50px;
    }  
`

export const animatetop = keyframes`
    from {
        top: -300px;
        opacity:  0;
    }

    to {
        top: 0px;
        opacity:  1;
    }
`;

export const ModalContent = styled(Tile)`
    position: relative;
    margin: auto;
    width: 80%;
    background-color: #333333; 
    box-shadow: 6px 18px 4px -15px #000000c4;
   /* 1px 19px 4px -15px #000000c4, 0px -9px 4px -7px #000000c4;*/
   animation: ${animatetop} .4s ease-in ;

    @media (max-width: 992px) {
        width: 80%; 
    }
    
    @media (max-width: 576px) {
        width: 94%;
       
    }  
`

export const PlaceholderAnimation  = styled.span`
    transition: padding-top .5s ease-out;
    transition: font-size .5s ease-out;
`

export const ModalHeader = styled(Title)`
    font-size: ${props => props.fontSize};
    padding: 0 10px;
    line-height: 37px;
    background-color: #333333;
`

export const ModalBody = styled(Body)`
    max-height: calc(100vh - 240px);
    color: white;
    overflow: hidden;
    width: 100%;
    background-color: #333333

    @media (max-width: 992px) {
        max-height: calc(100vh - 140px);
    }
    
    @media (max-width: 576px) {
        max-height: calc(100vh - 220px);
    }  
`
export const ModalFooter = styled(Body)`
    position: relative;
    height: 50px;
    color: white;
    overflow: hidden;
    width: 100%;
    background-color: rgb(60, 59, 59); 
    /*box-shadow: rgba(6, 6, 6, 0.54) 1px 0px 2px inset; */
    box-shadow:  #333333 0px -2px 0px, rgb(38,38,38) 0px 2px 0px, rgba(0,0,0,0.4) 0px 3px 3px, rgba(255,255,255,0.5) 0px 0px 3px inset, black 1px 1px 4px 1px inset, 0px -1px 14px -9px #f9f9f9
    border-bottom: 1px solid rgb(103, 98, 98);
    display: flex;
    justify-content:  ${props => props.justifyContent||'flex-end'};
    align-items: center;

    @media (max-width: 992px) {
        
    }
    
    @media (max-width: 576px) {
        
    }  
`



export const InerScroll = styled.div`
    max-height: calc(100vh - 250px);
    marginTop: 5px;
    overflow-y: auto;
    overflow-x: none;
    

    @media (max-width: 992px) {
        max-height: calc(100vh - 150px);
    }
    
    @media (max-width: 576px) {
        max-height: calc(100vh - 230px);
    }  
`

export const ModalInput = styled.input.attrs(props => ({
    // we can define static props
    backgroundColor: "#333333",
    color: "white",
    borderRadius: 0,
  }))`
    background-color: ${props => props.backgroundColor}
    color: ${props => props.color}
    border-radius: ${props => props.borderRadius}
`;

export const ModalTextarea = styled.textarea.attrs(props => ({
    // we can define static props
    backgroundColor: "#333333",
    color: "white",
    borderRadius: 0,
  }))`
    background-color: ${props => props.backgroundColor}
    color: ${props => props.color}
    border-radius: ${props => props.borderRadius}
`;

export const RmModal = styled.div`
    display: ${props => props.show ? 'block' : 'none' ||'none'};
    position: fixed; 
    z-index: 10001; 
    padding-top: 100px;
    padding-bottom: 100px;
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: ${props => props.overflow||'none'};
    color: ${props => props.color||'white'};
    background-color: #ffffff66; /* Fallback color */
   

    @media (max-width: 992px) {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    
    @media (max-width: 576px) {
        padding-top: 10px;
        padding-bottom: 50px;
    }  
`


export const RmModalContent = styled(Tile)`
    position: relative;
    margin: auto;
    width: 80%;
    background-color: #333333; 
    box-shadow: 6px 18px 4px -15px #000000c4;
   /* 1px 19px 4px -15px #000000c4, 0px -9px 4px -7px #000000c4;*/
   animation: ${animatetop} .4s ease-in ;

    @media (max-width: 992px) {
        width: 80%; 
    }
    
    @media (max-width: 576px) {
        width: 94%;
       
    }  
`


export const RmModalHeader = styled(Title)`
    font-size: ${props => props.fontSize};
    padding: 0 10px;
    line-height: 37px;
    background-color: #333333;
`

export const RmModalBody = styled(Body)`
    max-height: calc(100vh - 240px);
    color: white;
    overflow: hidden;
    width: 100%;
    background-color: #333333

    @media (max-width: 992px) {
        max-height: calc(100vh - 140px);
    }
    
    @media (max-width: 576px) {
        max-height: calc(100vh - 220px);
    }  
`
export const RmModalFooter = styled(Body)`
    position: relative;
    height: 50px;
    color: white;
    overflow: hidden;
    width: 100%;
    background-color: rgb(60, 59, 59); 
    /*box-shadow: rgba(6, 6, 6, 0.54) 1px 0px 2px inset; */
    box-shadow:  #333333 0px -2px 0px, rgb(38,38,38) 0px 2px 0px, rgba(0,0,0,0.4) 0px 3px 3px, rgba(255,255,255,0.5) 0px 0px 3px inset, black 1px 1px 4px 1px inset, 0px -1px 14px -9px #f9f9f9
    border-bottom: 1px solid rgb(103, 98, 98);
    display: flex;
    justify-content:  ${props => props.justifyContent||'flex-end'};
    align-items: center;

    @media (max-width: 992px) {
        
    }
    
    @media (max-width: 576px) {
        
    }  
`


export const RmModalInput = styled.input.attrs(props => ({
    // we can define static props
    backgroundColor: "#333333",
    color: "white",
    outline: "none",
    borderRadius: 0,
  }))`
    background-color: ${props => props.backgroundColor}
    color: ${props => props.color}
    border-radius: ${props => props.borderRadius}
    outline: ${props => props.outline}

`;

export const RmModalTextarea = styled.textarea.attrs(props => ({
    // we can define static props
    backgroundColor: "#333333",
    color: "white",
    borderRadius: 0,
  }))`
    background-color: ${props => props.backgroundColor}
    color: ${props => props.color}
    border-radius: ${props => props.borderRadius}
`;

